var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Eyes (1F440)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eyes-(1F440)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-9",
    fill: "#E7ECEF",
    cx: 28.0495495,
    cy: 49.5,
    rx: 22.0495495,
    ry: 33.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-9-Copy",
    fill: "#E7ECEF",
    cx: 72.9504505,
    cy: 49.5,
    rx: 22.0495495,
    ry: 33.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-9",
    fill: "#FFFFFF",
    cx: 26.4459459,
    cy: 49.5,
    rx: 18.8423423,
    ry: 31.1071429
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-9-Copy-2",
    fill: "#FFFFFF",
    cx: 71.3468468,
    cy: 49.5,
    rx: 18.8423423,
    ry: 31.1071429
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-11",
    fill: "#2C2839",
    cx: 18.4279279,
    cy: 51.4940476,
    rx: 10.0225225,
    ry: 11.5654762
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-11-Copy",
    fill: "#2C2839",
    cx: 63.3288288,
    cy: 51.4940476,
    rx: 10.0225225,
    ry: 11.5654762
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-12",
    fill: "#FFFFFF",
    cx: 14.018018,
    cy: 46.7083333,
    rx: 3.20720721,
    ry: 3.58928571
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-12-Copy",
    fill: "#FFFFFF",
    cx: 58.9189189,
    cy: 46.7083333,
    rx: 3.20720721,
    ry: 3.58928571
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/Eyes.f75c3ed7.svg";
export { ForwardRef as ReactComponent };